import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestNotificationPermission, showNotification } from 'src/utils';
import { clearNotification } from 'src/reducers/workSessions/workSessionsReducer';
import { getNotification } from 'src/reducers/workSessions/workSessionsSelectors';

export function useNotifications() {
  const dispatch = useDispatch();
  const notification = useSelector(getNotification);

  useEffect(() => {
    requestNotificationPermission();
  }, []);

  useEffect(() => {
    if (notification) {
      showNotification('Work Sessions', {
        body: notification,
      });

      dispatch(clearNotification());
    }
  }, [dispatch, notification]);
}
